module.exports = __webpack_public_path__ + "img/napoli.8dd1a802.png";